import { EntityRequestEntmt } from "../../entity/EntityRequestEntmt";

export class DtoRequestEntmtsPostRes extends EntityRequestEntmt {}
